import { useParams } from '@tanstack/react-router';

import { useWorkspacesGet } from '@/shared/api/generated/workspaces/workspaces';
import { unwrap } from '@/shared/api/unwrap';

/**
 * Пространство из адреса, если мы внутри него.
 *
 * Читает `$slug` из любого вложенного маршрута, поэтому годится и оболочке,
 * которая не знает, какой экран открыт. Вне пространства — `slug` пуст и
 * запрос не делается.
 */
export function useCurrentWorkspace() {
  const params = useParams({ strict: false });
  const slug = typeof params.slug === 'string' ? params.slug : '';

  const query = useWorkspacesGet(slug, {
    query: { select: unwrap, enabled: slug !== '' },
  });

  return {
    slug,
    workspace: query.data,
    isPending: slug !== '' && query.isPending,
    isError: query.isError,
  };
}
